import { useApiClient } from '@m43/core';
import { DuplicateEventSearchResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';

export function useEventDuplicateEventSearchQueryQuery({
    latitude,
    longitude,
    locationId,
    eventId,
}: {
    latitude?: number;
    longitude?: number;
    locationId?: number;
    eventId?: number;
}) {
    const apiClient = useApiClient();
    return useQuery(
        [
            'SearchForPotentialDuplicateAgencyEvents',
            latitude,
            longitude,
            locationId,
            eventId,
        ] as const,
        ({ queryKey }) => {
            if (queryKey[1] === undefined || queryKey[2] === undefined) {
                return Promise.resolve(undefined);
            }

            return apiClient
                .request<DuplicateEventSearchResource.SearchDuplicateEvents>({
                    method: 'POST',
                    url: 'duplicate_event_search/',
                    data: {
                        latitude: queryKey[1],
                        longitude: queryKey[2],
                        locationId: queryKey[3],
                        eventId: queryKey[4],
                    },
                })
                .then((resp) => {
                    return resp.data.data;
                });
        },
        {
            cacheTime: 15 * 60 * 1000,
            refetchInterval: 3000,
            keepPreviousData: true,
        }
    );
}
